// Quote bid-log vocabulary (P3-B) — the values Quotes.QuoteStatus and
// Quotes.ReviewStatus may hold (columns added in db/12, validated by
// sp_UpdateQuote in db/35). Two independent axes, never conflated:
//   QuoteStatus  — the vendor's side: what kind of offer this is
//   ReviewStatus — the estimator's side: what CleanSpace has done with it
// A quote that should not count toward coverage is 'excluded' (review) or
// 'withdrawn' (vendor) — the row itself is never deleted (evidence).

export const QUOTE_STATUSES = [
  { key: "budgetary", label: "Budgetary",  description: "Non-binding budget number; expect a formal quote before award." },
  { key: "formal",    label: "Formal",     description: "Firm, bid-able offer." },
  { key: "revised",   label: "Revised",    description: "A re-issue of an earlier quote (see Supersedes)." },
  { key: "withdrawn", label: "Withdrawn",  description: "Vendor pulled it; kept for the record, not counted toward coverage." },
];
export const QUOTE_STATUS_KEYS = QUOTE_STATUSES.map(s => s.key);

export const REVIEW_STATUSES = [
  { key: "unreviewed", label: "Unreviewed", description: "Received / extracted; not yet checked by an estimator." },
  { key: "reviewed",   label: "Reviewed",   description: "Checked; usable for leveling and carried pricing." },
  { key: "excluded",   label: "Excluded",   description: "Not to be used on this project (wrong scope, non-responsive, …). Kept for the record." },
];
export const REVIEW_STATUS_KEYS = REVIEW_STATUSES.map(s => s.key);
export const DEFAULT_REVIEW_STATUS = "unreviewed";
